import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";

import TableHeaderCell from "components/Table/TableHeaderCell";

const columns = ["Produit", "Attribut", "Impact", "Suggestion IA", "Statut", "", "Actions"];

function TableHeader({allChecked, onCheckAll}) {
    return (
        <TableHead>
            <TableRow>
                <TableHeaderCell padding="checkbox" sx={{padding: "12px 8px 12px 16px"}}>
                    <Checkbox
                        size="small"
                        checked={allChecked}
                        onChange={onCheckAll}
                        sx={{color: "#d1d5db", "&.Mui-checked": {color: "#4338ca"}}}
                    />
                </TableHeaderCell>
                {columns.map((col) => (
                    <TableHeaderCell key={col}>{col}</TableHeaderCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

export default TableHeader;
